import { render, staticRenderFns } from "./AssignAccountDataToSD.vue?vue&type=template&id=aef726d4&scoped=true"
import script from "./AssignAccountDataToSD.vue?vue&type=script&lang=js"
export * from "./AssignAccountDataToSD.vue?vue&type=script&lang=js"
import style0 from "./AssignAccountDataToSD.vue?vue&type=style&index=0&id=aef726d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef726d4",
  null
  
)

export default component.exports